import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout'
import AppForm from '../../components/AppForm';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';


export default function UserAdd() {
  return (
    <div style={{ margin: '2rem' }}>
      <AdminLayout  titleName='จัดการแอปพลิเคชัน'/>
      <Grid container style={{ marginTop: '4rem', marginBottom: '2rem' }}>
        <Grid item xs={12}>
          <Typography variant='h4' style={{ fontWeight: 'bold' }}>เพิ่มแอปพลิเคชัน</Typography>
        </Grid>
        <Grid item xs={12} >
          <AppForm mode='add' />
        </Grid>
      </Grid>
    </div>
  )
}